import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getSecondFlow = asyncThunkWrapper({ 
  model: 'secondFlow', 
  action: 'getSecondFlow', 
  func: async () => {
    const attributes = ['id', 'email', 'prompt', 'updated_at'];
    const params = { attributes };
    const response = await axios.get(`/second_flow`, { params });

    return response.data;
  } 
});
export const createSecondFlow = asyncThunkWrapper({ 
  model: 'secondFlow', 
  action: 'createSecondFlow', 
  func: async (second_flow) => {
    const attributes = ['id', 'email', 'prompt', 'updated_at'];
    const response = await axios.post(`/second_flow`, { second_flow, attributes });

    return response.data;
  } 
});
export const updateSecondFlow = asyncThunkWrapper({ 
  model: 'secondFlow', 
  action: 'updateSecondFlow', 
  func: async (second_flow) => {
    const response = await axios.patch(`/second_flow`, { second_flow });

    return { status: response.status, second_flow };
  } 
});
export const deleteSecondFlow = asyncThunkWrapper({ 
  model: 'secondFlow', 
  action: 'deleteSecondFlow', 
  func: async () => {
    const response = await axios.delete(`/second_flow`);

    return { status: response.status };
  } 
});
export const clearLocalActiveSecondFlow = createAction('secondFlow/clearLocalActiveSecondFlow');